import {Translation, TranslocoLoader} from '@ngneat/transloco';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {en} from './i18n/en';
import {ua} from './i18n/ua';
import {he} from './i18n/he';

@Injectable({ providedIn: 'root' })
export class InlineLoader implements TranslocoLoader {
  getTranslation(lang: string): Observable<Translation> {
    return new Observable<Translation>((observer) => {
      switch (lang) {
        case 'en':
          return observer.next(en);
        case 'he':
          return observer.next(he);
        case 'ua':
          return observer.next(ua);
      }
    })
  }
}
